import DomManipulate from "./DomManipulate";


/*
  diveTypes
      - simple: all selector elements have the same parent.
      - complex: some selector elements have a different parents
 */

const defaultParams = {
  diveType: 'simple'
}

export class SuperAlign {

  constructor(selector, params = defaultParams, callback = null) {
    this.selector = selector;
    this.diveType = params.diveType;
    this.callback = callback;
  }

  init() {
    const dom = new DomManipulate();
    let that = this;
    dom.onReady(() => {
      that.initNormalization();
      $(window).on('resize', function(){
        that.initNormalization();
      });
    });
  }

  initNormalization(){
    let that = this;
    that.resetNormalization();
    setTimeout(function (){
      if(that.diveType === 'simple'){
        that.calculatePerRow();
      }else{
        that.calculatePerCol();
      }
    }, 250);
  }

  calculatePerRow(){
    let theStack = [];
    let previous;
    let current;
    let thatObject = this;
    //Loop t
    $(thatObject.selector).each(function(index){


      let thatModel = this;

      if($(thatModel).is(":visible")){

        //Reset previous
        $(thatModel).css('height', '');
        current = Math.ceil($(thatModel).offset().top - $(document).scrollTop());

        //First element in row
        if(theStack.length === 0){

          theStack.push(index);
          previous = current;
        }else{
          if(current === previous || theStack.length === 1) { //Element in row

            theStack.push(index);
            previous = current;
          }else { //Breakline and add current in next line

            thatObject.normalize(theStack);
            theStack = [];
            previous = current;
            theStack.push(index);
          }
        }
      }
    });

    thatObject.normalize(theStack);

    if(this.callback != null){
      this.callback();
    }
  }

  resetNormalization(){
    document.querySelectorAll(this.selector).forEach(function(elem) {
      elem.querySelectorAll('*').forEach(function (element) {
        if (element && element.style)
          element.removeAttribute('style');
      });
    });
  }

  calculatePerCol(){
    let theStack = [];
    let thatObject = this;

    $(thatObject.selector).each(function(index){

      let thatModel = this;

      if($(thatModel).is(":visible")) {

        $(thatObject.selector).each(function(index2){

          let thatLoop = this;
          if( Math.ceil($(thatModel).offset().top - $(document).scrollTop()) === Math.ceil($(thatLoop).offset().top - $(document).scrollTop())){
            if(!theStack.includes(index2)){
              theStack.push(index2);
            }
          }
        });

        thatObject.normalize(theStack);
        theStack = [];
      }
    });

    if(this.callback != null){
      this.callback();
    }
  }



  normalize(stack){
    let theMax = [];

    //Loop in row
      for(var i = 0; i < stack.length; i++){

        //Find (loop in col elements)
        $(this.selector).eq(stack[i]).children().each(function(index){


          if(!$(this).hasClass('btn')){
            if(theMax[index] === null || theMax[index] === undefined){
              theMax.push($(this).height());
            }else{
              if($(this).height() > theMax[index]){
                theMax[index] = $(this).height();
              }
            }
          }

        });
      }

      for(var i = 0; i < stack.length; i++){
        //Find (loop in col elements)
        $(this.selector).eq(stack[i]).children().each(function(index){
          if(!$(this).hasClass('btn')){
            if(!$(this).hasClass('js-no-resize'))
              $(this).css('height', parseInt(theMax[index])+'px');
          }
        });
      }
  }
}




